import { FC, MouseEvent, useContext } from "react";
import { Maybe, Subcategory } from "@/generated/graphql";
import { UserContext } from "@/App";
import { formatAmount } from "@/utils/format";
import { AnchorActionDropdownElProps } from "@/hooks/useActionDropdown";
import { GroupRowStyled } from "@/components/list-group/list-group-style";
import { ListItemHeader } from "@/components/list-item-header/list-item-header";
import { IconMenu } from "@/components/icon-menu/icon-menu";
import {
  CategoryAmountStyled,
  CategoryDetailsStyled,
} from "../categories-list-style";

interface Props {
  subcategories: Subcategory[];
  canManage: boolean;
  anchorActionDropdownEl: AnchorActionDropdownElProps;
  handleOnEditSubcategory: (subcategory: Subcategory) => void;
  handleOnRemoveSubcategory: (subcategoryId: string) => void;
  handleActionsDropdownClick: (
    event: MouseEvent<HTMLElement>,
    anchorIndex: string,
  ) => void;
  handleActionsDropdownClose: (anchorIndex: string) => void;
}

export const CategorySubcategoriesList: FC<Props> = ({
  subcategories,
  canManage,
  anchorActionDropdownEl,
  handleOnEditSubcategory,
  handleOnRemoveSubcategory,
  handleActionsDropdownClick,
  handleActionsDropdownClose,
}) => {
  const userCurrency = useContext(UserContext);

  return (
    <>
      {subcategories.map((subcategory: Maybe<Subcategory>) => {
        if (!subcategory) return null;

        const subcategoryId = subcategory.id;

        return (
          <span key={subcategoryId}>
            <GroupRowStyled>
              <ListItemHeader title={subcategory.name} />
              <CategoryDetailsStyled>
                <CategoryAmountStyled>
                  {formatAmount(subcategory.budgetAmount || 0, userCurrency)}
                </CategoryAmountStyled>
                {canManage && (
                  <IconMenu
                    itemId={subcategoryId}
                    anchorActionDropdownEl={anchorActionDropdownEl}
                    handleOnEdit={() => handleOnEditSubcategory(subcategory)}
                    handleOnRemove={() =>
                      handleOnRemoveSubcategory(subcategoryId)
                    }
                    handleOnOpenMenu={(event: MouseEvent<HTMLElement>) =>
                      handleActionsDropdownClick(event, subcategoryId)
                    }
                    handleOnCloseMenu={() =>
                      handleActionsDropdownClose(subcategoryId)
                    }
                  />
                )}
              </CategoryDetailsStyled>
            </GroupRowStyled>
          </span>
        );
      })}
    </>
  );
};
